// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2XFea","empty":"ModalGraph_empty__AGNYO"};